export const isContentFeedCreativeSelected = (state) => {
	const creatives = state.creatives.items;
	const selectedCreatives = state.selected.creatives;

	if (!creatives || !selectedCreatives) {
		return false;
	}

	const selectedSet = new Set(selectedCreatives);
	return creatives.some(creative => selectedSet.has(creative.id) && creative.contentFeedUrl);
};
